// Auto-generated from rail.spec.js
export default {
  "tagName": "ui-rail"
};
